module.exports = "div.card {\n  margin-bottom: 1rem;\n}\nli.list-group-item-active {\n  background-color: #FFF8D9 !important;\n}\n"